import type { FolderTree, FolderTreeItem } from '@/api/model/folderModel'
import type {
  DestinationDetail,
  DestinationDetailList,
} from '@/api/send_cart/model/sendCartModel'
import type {
  Client,
  ResponsiblePerson,
} from '@/hooks/services/send-cart/useDestinationSelection'

import { SendCartTypeEnum } from '@/api/send_cart/model/sendCartModel'

export interface SelectedDestination {
  client: Client
  responsiblePerson: ResponsiblePerson
  folder: FolderTreeItem
}

export interface SendCartDestinationSelectionErrors {
  client?: string
  responsiblePerson?: string
  folder?: string
}

export interface State {
  sendCartType: SendCartTypeEnum

  // 送信先詳細リスト
  destinationDetailList: DestinationDetailList

  // 取引先リスト
  clientList: DestinationDetailList
  // 選択済み取引先
  selectedClient: DestinationDetail

  // 担当者リスト
  responsiblePersonList: DestinationDetailList
  // 選択済み取引先
  selectedResponsiblePerson: DestinationDetail

  // 他社商品フォルダ
  destinationFolderTree: FolderTree
  // 選択済み
  selectedFolder: FolderTreeItem

  // エラー
  errors: SendCartDestinationSelectionErrors
}

const state = (): State => ({
  sendCartType: SendCartTypeEnum.NORMAL,

  destinationDetailList: [],

  clientList: [],
  selectedClient: {} as DestinationDetail,

  responsiblePersonList: [],
  selectedResponsiblePerson: {} as DestinationDetail,

  destinationFolderTree: [],
  selectedFolder: {} as FolderTreeItem,

  errors: {} as SendCartDestinationSelectionErrors,
})

export default state
